'use client';

import { ChevronDown } from 'lucide-react';
import React, { useState } from 'react';
import Image from '@/lib/app-image';
import { getAirlineIconUrl } from '@/lib/airlineIcon';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';

const BookingSummary = () => {
  const userInput = useSelector((state: any) => state.userInputs);
  const stateData = useSelector((state: any) => state.flightSearch);
  const [flightSummary, isFlights] = useState(false);
  const { selectedFlight, travellerDetails, selectedReturnFlight } = userInput;

  const toggleDetails = () => {
    isFlights(!flightSummary);
  };
  return (
    <div className="mx-auto rounded-lg bg-white p-6 shadow-lg">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="text-lg font-semibold">Booking Summary</h3>
        <button
          className="curser-pointer rounded-full bg-primary p-0.5 text-white focus:outline-none"
          onClick={toggleDetails}
        >
          <ChevronDown
            className={`h-4 w-4 transform transition-transform duration-500 ${flightSummary ? 'rotate-180' : 'rotate-0'}`}
          />
        </button>
      </div>
      {!flightSummary && (
        <div className="delay-500 ease-in-out">
          <div className="mb-2 flex items-center gap-2">
            <Image
              src={getAirlineIconUrl(selectedFlight?.airline_logo)}
              alt={selectedFlight?.airline_code}
              width={30}
              height={30}
            />
            <div className="text-sm">
              <span className="font-semibold">
                {selectedFlight?.airline_code}
              </span>{' '}
              {selectedFlight?.flight_number}
            </div>
          </div>
          {selectedFlight &&
            'flightInfo' in selectedFlight &&
            selectedFlight.flightInfo?.map((flights: any, index: number) => (
              <div className="flex flex-col" key={index}>
                <div className="text-sm font-medium">
                  {' '}
                  {flights?.departure_city_name} - {flights?.arrival_city_name}
                </div>
                <div className="text-xs text-gray-600">
                  {flights?.departure_time} - {flights?.arrival_time},{' '}
                  {format(new Date(flights?.departure_date), 'dd MMM yy')},{' '}
                  {flights?.stops}
                </div>
              </div>
            ))}

          {selectedReturnFlight && stateData?.travelType === 'RT' && (
            <div className="ctm mb-2 flex items-center gap-2">
              <Image
                src={getAirlineIconUrl(selectedReturnFlight?.airline_logo)}
                alt={selectedReturnFlight?.airline_code}
                width={30}
                height={30}
              />
              <div className="text-sm">
                <span className="font-semibold">
                  {selectedReturnFlight?.airline_code}
                </span>{' '}
                {selectedReturnFlight?.flight_number}
              </div>
            </div>
          )}

          {selectedReturnFlight &&
            stateData?.travelType === 'RT' &&
            'flightInfo' in selectedReturnFlight &&
            selectedReturnFlight.flightInfo?.map(
              (flights: any, index: number) => (
                <div className="flex flex-col" key={index}>
                  <div className="text-sm font-medium">
                    {' '}
                    {flights?.departure_city_name} -{' '}
                    {flights?.arrival_city_name}
                  </div>
                  <div className="text-xs text-gray-600">
                    {flights?.departure_time} - {flights?.arrival_time},{' '}
                    {format(new Date(flights?.departure_date), 'dd MMM yy')},{' '}
                    {flights?.stops}
                  </div>
                </div>
              ),
            )}

          {travellerDetails && 'passengerDetails' in travellerDetails && (
            <div className="border-light mt-4 flex items-center justify-between border-y px-4 py-2.5">
              <div className="text-xs">
                {travellerDetails.passengerDetails[0]?.gender}
              </div>
              <div className="text-xs font-medium">
                {travellerDetails.passengerDetails[0]?.firstName}
              </div>
              <div className="text-xs">
                {travellerDetails.passengerDetails?.dateOfBirth}
              </div>
            </div>
          )}
          {travellerDetails && 'contactDetails' in travellerDetails && (
            <div className="border-light border-b px-4 py-2.5">
              <div className="text-xs">
                {travellerDetails.passengerDetails[0]?.firstName} (Primary)
              </div>
              <div className="text-xs">
                {travellerDetails?.contactDetails?.mobileNo}
                {','} {travellerDetails?.contactDetails?.emailId}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default BookingSummary;
